import { Injectable, Signal } from '@angular/core';
import { ICreditAgreementData, ICreditAgreementModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { CreditAgreementActions, CreditAgreementSelectors, ICreditAgreementState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class CreditAgreementStore extends StateAccessService<ICreditAgreementState> {
  readonly state$: Observable<ICreditAgreementState>;

  readonly data$$: Signal<ICreditAgreementData>;
  readonly model$$: Signal<ICreditAgreementModel>;

  constructor() {
    super();
    this.model$$ = this.stateFacade.selectSignal$(CreditAgreementSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(CreditAgreementSelectors.data);
  }

  dispatchCreditAgreementReset() {
    this.stateFacade.dispatch(CreditAgreementActions.reset());
  }
  dispatchUpdateCreditAgreementModel({ model }: { model: ICreditAgreementModel }) {
    this.stateFacade.dispatch(CreditAgreementActions.updateModel({ model }));
  }
  dispatchCreditAgreementLoad() {
    this.stateFacade.dispatch(CreditAgreementActions.load());
  }
  dispatchCreditAgreementLoadSuccess({ model, data }: { model: ICreditAgreementModel; data: ICreditAgreementData }) {
    this.stateFacade.dispatch(CreditAgreementActions.loadSuccess({ model, data }));
  }
  dispatchCreditAgreementSubmit() {
    this.stateFacade.dispatch(CreditAgreementActions.submit());
  }
  dispatchCreditAgreementSubmitSuccess({ model, data }: { model: ICreditAgreementModel; data: ICreditAgreementData }) {
    this.stateFacade.dispatch(CreditAgreementActions.submitSuccess({ model, data }));
  }
}
